export interface HeaderAccountIdentityInput {
  readonly username?: string | null;
  readonly email?: string | null;
}

/** Primary label for header account affordance — login nick, then email. */
export function resolveHeaderAccountIdentity(input: HeaderAccountIdentityInput): string {
  const username = input.username?.trim() ?? '';
  if (username.length > 0) {
    return username;
  }
  const email = input.email?.trim() ?? '';
  return email;
}

/** Short text shown inside the round header badge (monogram or compact nick). */
export function resolveHeaderAccountBadgeText(identity: string): string {
  if (identity.length === 0) {
    return '?';
  }

  const label = identity.includes('@')
    ? (identity.split('@')[0] ?? identity)
    : identity;

  if (label.length <= 3) {
    return label.toUpperCase();
  }

  const segments = label.split(/[._-]+/).filter((part) => part.length > 0);
  if (segments.length >= 2) {
    const first = segments[0];
    const second = segments[1];
    if (first !== undefined && second !== undefined) {
      return `${first.charAt(0)}${second.charAt(0)}`.toUpperCase();
    }
  }

  return label.charAt(0).toUpperCase();
}
